import Button from './ui/Button'

interface CompletionScreenProps {
  onReset: () => void
}

const CompletionScreen = ({ onReset }: CompletionScreenProps) => {
  return (
    <div className="max-w-5xl mx-auto text-center py-12">
      {/* 完了アイコン */}
      <div className="mb-8">
        <div className="w-24 h-24 mx-auto rounded-full bg-green-100 flex items-center justify-center">
          <svg
            className="w-14 h-14 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>

      {/* メッセージ */}
      <h2 className="text-2xl font-medium text-neutral-800 mb-4">
        ご入力ありがとうございました
      </h2>

      <p className="text-base text-neutral-600 mb-10">
        カルテの入力が完了しました。
        <br />
        スタッフが確認後、ご案内させていただきます。
      </p>

      {/* リセットボタン */}
      <div>
        <Button
          type="button"
          variant="secondary"
          size="large"
          onClick={onReset}
          className="min-w-[200px]"
        >
          最初に戻る
        </Button>
      </div>
    </div>
  )
}

export default CompletionScreen
